import { render, staticRenderFns } from "./DialogSendFile.vue?vue&type=template&id=3ac5458a&scoped=true"
import script from "./DialogSendFile.vue?vue&type=script&lang=js"
export * from "./DialogSendFile.vue?vue&type=script&lang=js"
import style0 from "./DialogSendFile.vue?vue&type=style&index=0&id=3ac5458a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac5458a",
  null
  
)

export default component.exports